import React from 'react';
import { motion } from 'framer-motion';
const fadeInUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function PrivacyPolicy() {
  return <div className="w-full bg-white" data-id="element-481">
      {/* Header */}
      <section className="bg-charcoal pt-20 pb-16 px-4" data-id="element-482">
        <div className="max-w-4xl mx-auto text-center" data-id="element-483">
          <motion.h1 initial="hidden" animate="visible" variants={fadeInUp} className="text-4xl md:text-5xl font-heading font-extrabold text-white uppercase tracking-tight mb-4" data-id="element-484">
            Privacy <span className="text-brand-red" data-id="element-485">Policy</span>
          </motion.h1>
          <motion.p initial="hidden" animate="visible" variants={fadeInUp} className="text-steel-300 font-body" data-id="element-486">
            Last Updated:{' '}
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            year: 'numeric'
          })}
          </motion.p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 px-4" data-id="element-487">
        <motion.div initial="hidden" animate="visible" variants={fadeInUp} className="max-w-3xl mx-auto prose prose-steel prose-headings:font-heading prose-headings:uppercase prose-headings:font-bold prose-h2:text-2xl prose-h2:text-charcoal prose-h2:mt-12 prose-h2:mb-4 prose-p:text-steel-600 prose-p:leading-relaxed prose-li:text-steel-600" data-id="element-488">
          <p data-id="element-489">
            At Merem Mobile Dustless Blasting Michigan, LLC ("Merem Blasting",
            "we", "us", or "our"), we respect your privacy and are committed to
            protecting your personal information. This Privacy Policy explains
            how we collect, use, and safeguard your information when you visit
            our website (meremblasting.com) or use our services.
          </p>

          <h2 data-id="element-490">1. Information We Collect</h2>
          <p data-id="element-491">
            We may collect personal information that you voluntarily provide to
            us when you:
          </p>
          <ul data-id="element-492">
            <li data-id="element-493">Request a quote or estimate through our contact forms</li>
            <li data-id="element-494">Call or text our business phone numbers</li>
            <li data-id="element-495">
              Communicate with us via email or social media (e.g., Facebook)
            </li>
          </ul>
          <p data-id="element-496">
            This information may include your name, email address, phone number,
            physical address/project location, and details or photos regarding
            your project.
          </p>

          <h2 data-id="element-497">2. How We Use Your Information</h2>
          <p data-id="element-498">
            We use the information we collect primarily to provide and improve
            our services. Specifically, we may use your information to:
          </p>
          <ul data-id="element-499">
            <li data-id="element-500">Respond to your inquiries and provide accurate estimates</li>
            <li data-id="element-501">
              Schedule and perform mobile blasting services at your location
            </li>
            <li data-id="element-502">Communicate with you regarding your project status</li>
            <li data-id="element-503">
              Send administrative information, such as invoices or policy
              updates
            </li>
          </ul>

          <h2 data-id="element-504">3. Information Sharing and Disclosure</h2>
          <p data-id="element-505">
            We do not sell, trade, or rent your personal information to third
            parties. We may share your information only in the following
            situations:
          </p>
          <ul data-id="element-506">
            <li data-id="element-507">
              <strong data-id="element-508">Service Providers:</strong> We may share data with trusted
              third-party vendors who assist us in operating our website,
              conducting our business, or servicing you (e.g., invoicing
              software), so long as those parties agree to keep this information
              confidential.
            </li>
            <li data-id="element-509">
              <strong data-id="element-510">Legal Requirements:</strong> We may disclose your
              information when required by law, court order, or governmental
              regulation.
            </li>
          </ul>

          <h2 data-id="element-511">4. Data Security</h2>
          <p data-id="element-512">
            We implement reasonable security measures to maintain the safety of
            your personal information. However, please note that no method of
            transmission over the Internet or method of electronic storage is
            100% secure. While we strive to protect your personal information,
            we cannot guarantee its absolute security.
          </p>

          <h2 data-id="element-513">5. Third-Party Links</h2>
          <p data-id="element-514">
            Our website may contain links to third-party websites (such as our
            Facebook page). We are not responsible for the privacy practices or
            the content of these third-party sites. We encourage you to read the
            privacy policies of any linked websites you visit.
          </p>

          <h2 data-id="element-515">6. Changes to This Privacy Policy</h2>
          <p data-id="element-516">
            We may update this Privacy Policy from time to time to reflect
            changes in our practices or for other operational, legal, or
            regulatory reasons. Any changes will be posted on this page with an
            updated revision date.
          </p>

          <h2 data-id="element-517">7. Contact Us</h2>
          <p data-id="element-518">
            If you have any questions or concerns about this Privacy Policy or
            our data practices, please contact us at:
          </p>
          <p data-id="element-519">
            <strong data-id="element-520">Merem Mobile Dustless Blasting Michigan, LLC</strong>
            <br data-id="element-521" />
            Fowlerville, MI
            <br data-id="element-522" />
            Phone: (517) 777-8088
          </p>
        </motion.div>
      </section>
    </div>;
}